import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseurlService {

  private readonly url: string;

  constructor() {
    const port: string = window.location.port;
    switch (port) {
      case '4200':
      case '8080':
        this.url = `http://${window.location.host.replace(/:.*$/g, '')}:8081`;
        break;
      default:
        if (window.location.href.includes('ng.stranner.org')) {
          this.url = 'https://api.stranner.org';
        } else {
          this.url = '';
        }
        break;
    }
    console.log(`we are at port ${port} therefore determined api to be at ${this.url}`);
  }

  getBaseUrl(): string {
    // return 'https://api.stranner.org';
    return this.url;
  }

  getWsBaseUrl() {
    return this.getBaseUrl().replace(/^http/, 'ws');
  }
}
